export const MINIMUM_BATCH_SIZE = 100;
export const THRESHOLD_DEFAULT = 10;
export const DEFAULT_ITEM_SIZE = 30;
